import { useEffect, useMemo, useRef, useState } from "react";
import { ICONS, IconsComponent } from "../../utils/iconsv2";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import VisibilityIcon from "@mui/icons-material/Visibility";
import "./index.css";
import { MOODLE_STRINGS, TIPDDY_MODULES } from "../../services/tipddy-v2/state";
import meet from "../../assets/online/meet.png";
import teams from "../../assets/online/teams.png";
import zoom from "../../assets/online/zoom.png";
import { useTheme } from "../../contexts/ThemeContext";
import { opacify, readableColor, transparentize } from "polished";
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import DoneIcon from '@mui/icons-material/Done';
import { setActivityProgressCompletedManually } from "../../services/moodle/courses";
import { useAuth } from "../../contexts/AuthContext";
import { useConfig } from "../../contexts/config";
import useActivityCompleted from "../../hooks/useActivityCompleted";
const onlineicons = {
  meet: meet,
  teams: teams,
  zoom: zoom,
};

export const ResourceLabelComponent = ({
  module,
  resource,
  moodle,
  container,
  isCurrentModule,
  idx,
  contentFixedBar,
  prevResourceRef,
  onCompletionChange,
}) => {
  const theme = useTheme();
  const moduleRef = useRef(null);
  const {config} = useConfig();
  const { iframeLoaded, setIframeLoaded, currentModules } = moodle;
  const [isCurrentResource, setCurrentResource] = useState(null);
  // const [refreshHandler, setRefreshHandler] = useState(0);
  const [textColorByContrast, setTextColorByContrast] = useState("");
  const [visible, setVisible] = useState(false);
  const [isCompleted, setIsCompleted] = useState(false);
  const { resourceIsTracked, resourceIsCompleted, disabledCompleteAcivity, setResourceIsTracked, setResourceIsCompleted, setDisabledCompleteAcivity, handleCompletedActivity } = useActivityCompleted(resource);

const shouldRestrictResource = useMemo(() => {
  console.log({
    resourceName: resource.name,
    prevRef: prevResourceRef?.isCompleted,
    resourceCompleted: resourceIsCompleted,
    uservisible: resource.uservisible,
    visible: resource.visible,
    // Añade esto para depurar la lógica final:
    opacityReduced: !resourceIsCompleted && !prevResourceRef?.isCompleted
  });
  
  // Si no hay recurso anterior o no es un recurso visible, no aplicar opacidad reducida
  if (!prevResourceRef || !(resource.uservisible === true && resource.visible === 1) ||
      !resourceIsTracked) {
    return false;
  }
  
  // Opacidad reducida SOLO cuando:
  // 1. El recurso actual NO está completado Y
  // 2. El recurso anterior TAMPOCO está completado
  return !resourceIsCompleted && !prevResourceRef.isCompleted;
}, [resourceIsCompleted, prevResourceRef, resource.uservisible, resource.visible,resourceIsTracked]);
  
  // Notificar al padre sobre cambios en el estado de completado
  useEffect(() => {
    if (onCompletionChange && resource.uservisible === true && resource.visible === 1) {
      console.log(`Notificando cambio para ${resource.name}: ${resourceIsCompleted}`);
      onCompletionChange(resourceIsCompleted);
    }
  }, [resourceIsCompleted, onCompletionChange, resource.uservisible, resource.visible]);

  useEffect(() => {
    setVisible(true);
  }, []);

  useEffect(() => {
    /*   if (theme) {
      if(theme.mode === "dark"){
        setTextColorByContrast(
          readableColor(isCurrentModule ? theme.colors.backgroundColorCurrentModule : theme.colors.backgroundColorNotCurrentModule, "#1a1a1a", "#f2f2f2", false)
        );
      } else {
        setTextColorByContrast(
          readableColor(isCurrentModule ? theme.colors.backgroundColorCurrentModule : "#fff", "#1a1a1a", "#f2f2f2", false)
        );
      }
    } */
    // eslint-disable-next-line
  }, [theme]);

  useEffect(() => {
    let isCurrent = resource.id === moodle.currentResourceId;
    // console.log({ resource });
    setCurrentResource(isCurrent);
    // setRefreshHandler(refreshHandler + 1);
    // eslint-disable-next-line
  }, [moodle.currentResourceId]);

  useEffect(() => {
    console.log(resource)
    if (resource.tipddytype === "label") {
      setCurrentResource(true);
    }
    if (resource.completiondata && resource.completiondata.state === 0) {
      setIsCompleted(false);
    }

    if (resource.completiondata && resource.completiondata.state !== 0) {
      setIsCompleted(true);
    }
    if(resource.isTracked){
      setResourceIsTracked(true)
    } else {
      setResourceIsTracked(false)
    }
    if(resource.isCompleted){
      setResourceIsCompleted(true)
    } else {
      setResourceIsCompleted(false)
    }
  }, [resource]);



  const handleResourceSelected = async () => {
    let isRestricted = shouldRestrictResource;
    if(isRestricted){
      return;
    }
    /* console.log({ resource }); */
    const ua = navigator.userAgent;
    const iOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isMobileDevice =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(ua);
    if (resource.tipddytype === "label") {
      return;
    }

    // For all resource types, prepare to scroll to top if on mobile
    const scrollToTopIfMobile = () => {
      if (iOS || isMobileDevice) {
        document.getElementById("course-wrapper").scrollTo({top: 0, left: 0, behavior: 'smooth' })
      }
    };
    if (resource.tipddytype === MOODLE_STRINGS.PROGRAMS) {
      moodle.setPageEmbed(resource.tipddyurl);
      scrollToTopIfMobile();
    }
    if (
      resource.tipddytype === MOODLE_STRINGS.ONLINE &&
      moodle.selectedView === 2 &&
      !resource.embed
    ) {
      window.open(resource.onlineurl);
      return;
    }
    if (
      resource.tipddytype === MOODLE_STRINGS.ONLINE &&
      moodle.selectedView === 2 &&
      resource.embed
    ) {
      setIframeLoaded(false);
      await moodle.requestPageEmbed({
        pageurl: resource.url,
        module,
        resource,
        course_id: moodle.currentCourseId,
      });

      scrollToTopIfMobile();
      return;
    }
    if (
      resource.tipddytype === MOODLE_STRINGS.ONLINE &&
      moodle.selectedView !== 2
    ) {
      setIframeLoaded(false);
      return;
    }

    if (!isMobileDevice && currentModules) {
      setTimeout(() => {
        const container = document.getElementById("scrollable-modules-wrapper");
        const activeResource = moduleRef.current;
        // const activeModule = document.getElementById("current-active-module")

        // const resourceElements = Array.from(activeModule.nextElementSibling.children);
        // const index = resourceElements.indexOf(activeResource);

        if (container && activeResource) {
          const containerRect = container.getBoundingClientRect();
          const resourceRect = activeResource.getBoundingClientRect();
          const stickyOffset = contentFixedBar || 0;
          const spacingOffset = 2 * 100;

          const offsetTop = container.scrollTop + (resourceRect.top - containerRect.top) - stickyOffset - spacingOffset;

          container.scrollTo({
            top: offsetTop,
            behavior: "smooth",
          });
        }
      }, 450);
    }

    console.log({
      pageurl: resource.url,
      module,
      resource,
      course_id: moodle.currentCourseId,
    });
    setIframeLoaded(false);
    await moodle.requestPageEmbed({
      pageurl: resource.url,
      module,
      resource,
      course_id: moodle.currentCourseId,
    });
    if (iOS || isMobileDevice) {
      scrollToTopIfMobile();
    } else if (
      isCurrentResource &&
      container &&
      container.current &&
      idx !== 0
    ) {
      console.log("offset", moduleRef.current.offset);
      container.current.scrollTo({
        top: moduleRef.current.offset,
        behavior: "smooth",
      });
    }
  };

  /*  console.log(resource.tipddytype)
  console.log(moodle.selectedView)
  console.log(resource.tipddyname)
  console.log(resource.name) */
  /* if(resource.name === "Este curso no posee sesiones en línea"){
    return (
      <div>
        <p style={{color: "white"}}>Este curso no posee sesiones en línea</p>
      </div>
    )
  } */
  if (
    resource.tipddytype === MOODLE_STRINGS.PROGRAMS &&
    moodle.selectedView !== 1
  ) {
    return null;
  }

  if (resource.tipddytype === TIPDDY_MODULES.schedule) {
    return null;
  }

  if (resource.tipddyname === "summary") {
    return null;
  }

  if (resource.tipddyname === TIPDDY_MODULES.humhub) {
    return null;
  }

  /*
   * El siguiente condicional es para evitar mostrar recursos ocultos
   * uservisible tiende ser igual a 0, cuando el usuario no pertenece al grupo del curso que puede ver el recurso
   * visible tiende ser igual a 0, cuando el recurso esta oculto (roles como administrador pueden visualizarlo)
   * visibleoncoursepage tiende ser igual a 0, cuando el recurso esta oculto pero disponible
   */
  /*  if (
    !resource.uservisible ||
    resource.visible === 0 ||
    resource.visibleoncoursepage === 0
  ) {
    return null;
  } */

  return (
    <div
      ref={moduleRef}
      className={`resource-label-wrapper ${
        isCurrentResource ? "current-resource-item" : ""
      }`}
      style={{
        display: "flex",
        alignItems: "center",
        margin: "0px 15px 0px 0px" /* cambiado de 25px a cero en bottom */,
        /* paddingBottom:"10px", comentado por Agustin Rojas */
        /* padding: "15px 0px", */
        cursor: shouldRestrictResource ? "default" : "pointer",
        marginRight: "15px",
        zIndex: 1000,
        opacity: visible ? 1 : 0,
        transform: visible ? "translateY(0)" : "translateY(-20px)",
        transition: "opacity 0.5s ease, transform 0.5s ease",
        /* opacity:
          (resource.tipddytype === MOODLE_STRINGS.ONLINE &&
            moodle.selectedView !== 0) ||
          (resource.tipddytype === MOODLE_STRINGS.PROGRAMS &&
            moodle.selectedView !== 0)
            ? 1
            : isCurrentResource
            ? 1
            : 0.8, */
      }}
    >
      <div
        disabled={disabledCompleteAcivity}
        style={{ marginRight: "15px", padding: "15px 0px" }}
        className="z-50"
        onClick={handleCompletedActivity}
      >
        {resourceIsTracked ? (
          resourceIsCompleted ? (
            <div
              style={{
                borderColor: transparentize(
                  0.3,
                  readableColor(theme.colors.backgroundColorDetailCourse)
                ),
                backgroundColor:
                  theme.mode === "light"
                    ? theme.colors.backgroundColorIndexRow
                    : theme.colors.backgroundColorIndexRow,
              }}
              className="rounded-full  border-2 size-11 flex justify-center items-center"
            >
              <DoneAllIcon /* el visto */
                sx={{
                  color: readableColor(theme.colors.backgroundColorIndexRow),
                  fontSize: 20,
                  opacity: resourceIsCompleted ? 0.8 : 0.2,
                }}
              />
            </div>
          ) : config.opciones && config.opciones.includes("completadomanual") ? (
            <div
              className="rounded-full border-2 size-11 flex justify-center items-center"
              style={{
                borderColor: transparentize(
                  0.3,
                  readableColor(theme.colors.backgroundColorDetailCourse)
                ),
              }}
            >
              <DoneIcon
                sx={{
                  color: readableColor(
                    theme.colors.backgroundColorDetailCourse
                  ),
                  fontSize: 22,
                  /* opacity: resourceIsCompleted ? 0.8 : 0.2, */
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                  "&:hover": {
                    opacity: 0.8,
                  },
                }}
              />
            </div>
          ) : (
            <div
              className="rounded-full border-2 size-11 flex justify-center items-center opacity-20"
              style={{
                borderColor: transparentize(
                  0.3,
                  readableColor(theme.colors.backgroundColorDetailCourse)
                ),
              }}
            ></div>
          )
        ) : (
          <div className="w-11 h-full"></div>
        )}
      </div>
      <div
        className=" grow"
        style={{ padding: "15px 0px" }}
        onClick={handleResourceSelected}
      >
        <p
          className="resource-container "
          style={{
            color: readableColor(theme.colors.backgroundColorDetailCourse),
            margin: 0,
            marginLeft: resource.indent * 5,
            opacity: shouldRestrictResource ? 0.5 : 1, // Aquí aplicamos la opacidad reducida
            fontSize:
              resource.tipddytype === MOODLE_STRINGS.ONLINE ||
              resource.tipddytype === MOODLE_STRINGS.PROGRAMS
                ? "15px"
                : isCurrentResource
                ? "14px"
                : "14px",
            fontWeight: isCurrentResource ? "700" : "400",
            /* textDecoration: isCurrentResource ? "underline" : "none", */
          }}
        >
          {resource.name}
        </p>
        {resource.tipddytype === MOODLE_STRINGS.ONLINE &&
          moodle.selectedView === 0 && (
            <p
              className="resource-container"
              style={{
                color: "#333",
                margin: 0,
                fontSize: "10px",
              }}
            >
              Recurso disponible en clases en linea
            </p>
          )}
      </div>

      {moodle.selectedView !== 2 && (
        <div style={{ marginLeft: "auto" }}>
          <IconsComponent
            resource={resource.tipddyname}
            color={readableColor(theme.colors.backgroundColorDetailCourse)}
          />
        </div>
      )}
      {moodle.selectedView === 2 && resource.tipddyname && (
        <div style={{ marginLeft: "auto" }}>
          <img
            alt="...icon"
            src={onlineicons[`${resource.tipddyname}`]}
            width="18px"
            style={{ marginRight: "12px", marginBottom: 3 }}
          />
        </div>
      )}
    </div>
  );
};


/* 
<VisibilityIcon 
sx={{
  color: readableColor(theme.colors.backgroundColorDetailCourse),
  fontSize: 22,
  opacity: 0.6,
}}
/>
*/